import { getExtensionFromFileName } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

const textFileExtensions: string[] = ['.txt', '.xml', '.log'];

export default function shouldPreviewText(attachment: AttachmentType): boolean {
    const extension: string = getExtensionFromFileName(attachment.Name);

    if (extension) {
        return textFileExtensions.indexOf(extension.toLowerCase()) >= 0;
    }

    return false;
}
